/**
 * Sprung nach konto.elbklar.com — den persoenlichen Einstellungen.
 *
 * Alles, was am User haengt (Profil, Benachrichtigungen), liegt dort zentral:
 * eine Oberflaeche statt einer Kopie je App. Was an der Firma haengt
 * (Tenant-Config unter `/settings`), bleibt hier.
 *
 * `?redirect=` nimmt die Adresse mit, zu der die Konto-Seite zurueckfuehren
 * soll. Standard ist die aktuelle Seite — ausser man springt von einer
 * Weiterleitung ab, die einen dann sofort wieder wegschicken wuerde.
 */

const KONTO_URL = import.meta.env.VITE_ACCOUNT_URL || 'https://konto.elbklar.com';

export function kontoUrl(
  pfad: '/profil' | '/benachrichtigungen',
  zurueck: string = window.location.href,
): string {
  return `${KONTO_URL}${pfad}?redirect=${encodeURIComponent(zurueck)}`;
}
